module.exports = __webpack_public_path__ + "img/Secondary-chevron.2be42e60.svg";